<template>
  <v-app-bar app>
    <!-- <v-app-bar-nav-icon @click.stop="onClickBtn"/> -->
    <v-toolbar-title>
      <v-btn class="default v-btn--simple" dark icon @click.stop="onClickBtn" :id="'buttonToolbar_drawer'">
        <v-icon>mdi-view-list</v-icon>
      </v-btn>
      {{ $route.name }}
    </v-toolbar-title>

    <v-spacer />

    <v-toolbar-items>
      <v-flex align-center layout py-2>
        <v-menu bottom left content-class="dropdown-menu" offset-y transition="slide-y-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on" class="toolbar-items" :id="'buttonToolbar_menu'">
              <span color="success" v-if="!responsive">{{ username }}</span> &nbsp; <v-icon
                color="tertiary">mdi-account</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-subheader v-if="responsive">{{ username }}</v-subheader>
            <v-list-item @click='changePass' :id="'button_change_password'">Change password</v-list-item>
            <v-list-item to="/logout" :id="'button_logout'">
              Logout
            </v-list-item>
          </v-list>
        </v-menu>
      </v-flex>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { differenceInDays, startOfDay } from 'date-fns';


export default {
  data: () => ({
    title: null,
    responsive: false,
    responsiveInput: false,
    on: null,
  }),
  computed: {
    ...mapState(['user']),
    username() {
      return `${this.user.first_name} ${this.user.last_name} (${this.user.role})`
    }
  },
  mounted() {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)

    const password_expire = this.user.password_expire

    if (password_expire) {
      const password_expire_date = new Date(password_expire)
      const today = new Date()
      const in_ten_days = new Date()
      in_ten_days.setDate(today.getDate() + 10)

      if (password_expire_date < in_ten_days) {
        const days = differenceInDays(
          startOfDay(password_expire_date),
          startOfDay(today)
        )
        this.$root.$emit("openSnackbar", {
          message: `Your password is expiring in ${days} days, please change it.`,
          color: "warning"
        })

      }
    }

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onClickBtn() {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    onClick() {
      //
    },
    changePass() {
      this.$store.dispatch("app/openChangePassword", {
        title: "Change password!"
      });
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true
        this.responsiveInput = false
      } else {
        this.responsive = false
        this.responsiveInput = true
      }
    }
  }
}
</script>

<style>
/* #core-toolbar a {
  text-decoration: none;
}
.v-toolbar {
  margin-bottom:0px !important;
} */
</style>
